module.exports = __webpack_public_path__ + "media/images/company/cp01-a1670d73f33ce8577c9891082726a68b.png";